<!-- <p-progressSpinner *ngIf="!initialized" fxFlex="1 1 auto" class="spinner" animationDuration="2s"></p-progressSpinner> -->
<div fxFlex="1 1 auto" fxLayout="column">
    <div *ngIf="currency" fxFlex="0 0 auto" fxLayout="row">
        <span fxFlex="1 1 auto" class="mend-currency liquitics-h1">{{currency}}</span>
        <!-- <span fxFlex="1 1 auto" class="mend-summary-value liquitics-h3">In: {{round(inAmount) }}</span>
        <span fxFlex="1 1 auto" class="liquitics-h3">Out: {{round(outAmount) }}</span>
        <span fxFlex="1 1 auto" class="liquitics-h3">Throughput(Rec/Pay): {{recThroughputPercentage | percent }} / {{payThroughputPercentage | percent }}</span> -->
        <mat-button-toggle-group #nostroviewmodegroup="matButtonToggleGroup" (change)="onNostroViewModeChange($event)" [vertical]="false">
            <mat-button-toggle class="" value="INTRADAY" [checked]="nostroViewMode === 'INTRADAY'" matTooltip="Intraday View" matTooltipPosition="below">
                <span>Intraday</span>
            </mat-button-toggle>
            <mat-button-toggle class="" value="BY_PRODUCT_TYPE" [checked]="nostroViewMode === 'BY_PRODUCT_TYPE'" matTooltip="Breakdown by Product Type"
                matTooltipPosition="below">
                <span>By Product Type</span>
            </mat-button-toggle>
            <mat-button-toggle class="" value="BY_CLIENT_GROUP" [checked]="nostroViewMode === 'BY_CLIENT_GROUP'" matTooltip="Breakdown by Client Group"
                matTooltipPosition="below">
                <span>By Client Group</span>
            </mat-button-toggle>

        </mat-button-toggle-group>
    </div>
    <app-throughput *ngIf="currency" [fxHide]="nostroViewMode !== 'INTRADAY'" fxFlex="1 1 auto"></app-throughput>
    <app-explain [fxHide]="nostroViewMode === 'INTRADAY'" [explainMode]="'MULTI_ENTITY_NOSTRO'" fxFlex="1 1 auto"></app-explain>
</div>